{
  "api": {
    "locationValidationTitle": "位置情報を確認できませんでした",
    "thresholdTitle": "チェックイン可能な時間ではありません",
    "warehouseUnavailableTitle": "倉庫は利用できません",
    "warehouseUnavailableMessage": "手動チェックインを行うには、施設の担当者にお問い合わせください",
    "characterLimitTitle": "入力が文字数制限を超えています",
    "genericTitle": "チェックインに失敗しました。もう一度お試しください。",
    "recaptchaTitle": "認証に失敗しました",
    "recaptchaMessage": "リクエストを確認できませんでした。もう一度お試しいただくか、施設の担当者にお問い合わせください。"
  }
}
